import type { Action } from 'redux-actions';
import { takeEvery } from 'redux-saga/effects';

import { bumpActions } from 'app-components/flux/bump';

import createSharedState from 'hooks/createSharedState';

const MAX_TRACKED = 20;

const [useSharedStateBump, getSharedStateBump, setSharedStateBump] = createSharedState<{
  count: number;
  actions: Action<any>[];
}>({
  count: 0,
  actions: [],
});

export { useSharedStateBump };

function* receiveBumpMessageActionWatcher() {
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  yield takeEvery(bumpActions.receivedBumpMessage, function* receiveBumpMessage(action: Action<any>) {
    const sharedStateBump = getSharedStateBump();
    setSharedStateBump({
      count: sharedStateBump.count + 1,
      actions: [...sharedStateBump.actions, action].slice(-MAX_TRACKED),
    });
  });
///////////
}

export default [receiveBumpMessageActionWatcher];
